'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withMaskedDate = undefined;

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _equals2 = require('ramda/src/equals');

var _equals3 = _interopRequireDefault(_equals2);

var _startsWith2 = require('ramda/src/startsWith');

var _startsWith3 = _interopRequireDefault(_startsWith2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n\n    input {\n        padding-left: 24px;\n    }\n\n    svg {\n        position: absolute;\n        top: 12px;\n        left: 8px;\n        z-index: 1;\n        color: #6f869f;\n    }\n'], ['\n    position: relative;\n\n    input {\n        padding-left: 24px;\n    }\n\n    svg {\n        position: absolute;\n        top: 12px;\n        left: 8px;\n        z-index: 1;\n        color: #6f869f;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rifm = require('rifm');

var _fa = require('react-icons/fa');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

var _StyledInput = require('./StyledInput');

var _Age = require('../functions/Age');

var _Age2 = _interopRequireDefault(_Age);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Masked = _styledComponents2.default.div(_templateObject);

var isInvalid = (0, _startsWith3.default)('Invalid');
var parseDigits = function parseDigits(string) {
    return (string.match(/\d+/g) || []).join('');
};

var formatDate = function formatDate(string) {
    var digits = parseDigits(string);
    var chars = digits.split('');
    return chars.reduce(function (r, v, index) {
        return index === 2 || index === 4 ? r + '.' + v : '' + r + v;
    }, '').substr(0, 10);
};

var formatDateWithAppend = function formatDateWithAppend(string) {
    var res = formatDate(string);

    if (string.endsWith('.')) {
        if (res.length === 2) {
            return res + '.';
        }

        if (res.length === 5) {
            return res + '.';
        }
    }

    return res;
};

var formatMonth = function formatMonth(string) {
    var digits = parseDigits(string);
    var chars = digits.split('');
    return chars.reduce(function (r, v, index) {
        return index === 2 ? r + '.' + v : '' + r + v;
    }, '').substr(0, 7);
};

var formatMonthWithAppend = function formatMonthWithAppend(string) {
    var res = formatMonth(string);

    if (string.endsWith('.')) {
        if (res.length === 2) {
            return res + '.';
        }
    }

    return res;
};

var formatYear = function formatYear(string) {
    var digits = parseDigits(string);
    var chars = digits.split('');
    return chars.reduce(function (r, v) {
        return '' + r + v;
    }, '').substr(0, 4);
};

var formatYearWithAppend = function formatYearWithAppend(string) {
    var res = formatYear(string);

    return res;
};

var appendDate = function appendDate(v) {
    return v.length === 2 || v.length === 5 ? v + '.' : v;
};
var appendMonth = function appendMonth(v) {
    return v.length === 2 ? v + '.' : v;
};
var appendYear = function appendYear(v) {
    return v;
};

var MaskedDateInputComponent = function (_Component) {
    _inherits(MaskedDateInputComponent, _Component);

    function MaskedDateInputComponent(props) {
        _classCallCheck(this, MaskedDateInputComponent);

        var _this = _possibleConstructorReturn(this, (MaskedDateInputComponent.__proto__ || Object.getPrototypeOf(MaskedDateInputComponent)).call(this, props));

        _initialiseProps.call(_this);

        var date = _this.getPickerValue(props.value || {});
        _this.state = {
            masked: date && !isInvalid(date[0]) ? date[0].replace(/\//gi, '.') : ''
        };
        return _this;
    }

    _createClass(MaskedDateInputComponent, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(next) {
            var currentDate = this.getPickerValue(this.props.value || {});
            var nextDate = this.getPickerValue(next.value || {});

            if (!(0, _equals3.default)(currentDate, nextDate)) {
                if (next.value && !isInvalid(nextDate[0])) {
                    this.setState({
                        masked: nextDate[0].replace(/\//gi, '.')
                    });
                } else {
                    this.setState({
                        masked: next.value ? next.value.masked : ''
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var masked = this.state.masked;
            var _props = this.props,
                disabled = _props.disabled,
                label = _props.label,
                item = _props.item,
                value = _props.value;

            var hasAge = (0, _path3.default)(['function'], item) === 'calc_age';
            var isYear = this.isYearPicker();
            var isMonth = this.isMonthPicker();

            return _react2.default.createElement(
                Masked,
                null,
                _react2.default.createElement(_fa.FaCalendarAlt, null),
                _react2.default.createElement(
                    _rifm.Rifm,
                    {
                        accept: /\d+/g,
                        mask: (isYear ? 4 : isMonth ? 7 : 10) <= ('' + (masked || '')).length,
                        append: isYear ? appendYear : isMonth ? appendMonth : appendDate,
                        format: isYear ? formatYearWithAppend : isMonth ? formatMonthWithAppend : formatDateWithAppend,
                        value: masked,
                        onChange: this.onChange
                    },
                    function (_ref) {
                        var value = _ref.value,
                            onChange = _ref.onChange;
                        return _react2.default.createElement(_StyledInput.StyledInput, {
                            widthCalc: hasAge ? 125 : null,
                            value: value,
                            onChange: onChange,
                            disabled: disabled,
                            placeholder: label
                        });
                    }
                ),
                hasAge && _react2.default.createElement(_Age2.default, { value: value })
            );
        }
    }]);

    return MaskedDateInputComponent;
}(_react.Component);

MaskedDateInputComponent.propTypes = {
    item: _propTypes2.default.object,
    value: _propTypes2.default.object,
    label: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.isYearPicker = function () {
        return (0, _path3.default)(['input', 'type'], _this2.props) === 'year';
    };

    this.isMonthPicker = function () {
        return (0, _path3.default)(['input', 'type'], _this2.props) === 'month_year';
    };

    this.getPickerValue = function (date) {
        return _this2.isYearPicker() ? (0, _experiumPlayerHelpers.getEncodedYearData)(date) : _this2.isMonthPicker() ? (0, _experiumPlayerHelpers.getEncodedMonthData)(date) : (0, _experiumPlayerHelpers.getEncodedDateData)(date);
    };

    this.onChange = function (masked) {
        _this2.setState({ masked: masked });
        var isYear = _this2.isYearPicker();
        var isMonth = _this2.isMonthPicker();

        if (masked && ('' + masked).length === (isYear ? 4 : isMonth ? 7 : 10)) {
            var formatted = masked.replace(/\./gi, '/');
            var date = isYear ? (0, _experiumPlayerHelpers.getDecodedYearData)(formatted) : isMonth ? (0, _experiumPlayerHelpers.getDecodedMonthData)(formatted) : (0, _experiumPlayerHelpers.getDecodedDateData)(formatted);
            var valid = Date.parse(date.year + '-' + (date.month + 1 ? ('0' + (date.month + 1)).slice(-2) : '01') + '-' + (('0' + date.day).slice(-2) || '01') + 'T00:00:00');

            _this2.props.onChange(!Number.isNaN(valid) ? date : { invalid: true, masked: masked });
        } else {
            if (masked) {
                _this2.props.onChange({ invalid: true, masked: masked });
            } else {
                _this2.props.onChange(null);
            }
        }
    };

    this.isValid = function (masked) {
        var isYear = _this2.isYearPicker();
        var isMonth = _this2.isMonthPicker();

        if (masked && ('' + masked).length === (isYear ? 4 : isMonth ? 7 : 10)) {
            var formatted = masked.replace(/\./gi, '/');
            var date = _this2.isYearPicker() ? (0, _experiumPlayerHelpers.getDecodedYearData)(formatted) : _this2.isMonthPicker() ? (0, _experiumPlayerHelpers.getDecodedMonthData)(formatted) : (0, _experiumPlayerHelpers.getDecodedDateData)(formatted);
            var valid = Date.parse(date.year + '-' + (date.month + 1 ? ('0' + (date.month + 1)).slice(-2) : '01') + '-' + (('0' + date.day).slice(-2) || '01') + 'T00:00:00');

            return !Number.isNaN(valid);
        } else {
            return false;
        }
    };

    this.onBlur = function () {
        var masked = _this2.state.masked;

        var isValid = _this2.isValid(masked);

        if (!isValid) {
            _this2.onChange('');
        }
    };
};

var MaskedComponents = (0, _withFieldWrapper2.default)(MaskedDateInputComponent);

var withMaskedDate = exports.withMaskedDate = function withMaskedDate(DateComponent) {
    return function (props) {
        return (0, _path3.default)(['item', 'mask'], props) ? _react2.default.createElement(MaskedComponents, props) : _react2.default.createElement(DateComponent, props);
    };
};

exports.default = MaskedComponents;